/* import __COLOCATED_TEMPLATE__ from './event.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import ENV from 'bullitttime-event/config/environment';

export default class EventUploadComponent extends Component 
{
	@service store;

	@tracked error = "";
	
	@action
	async uploadFile(file)
	{
		var url = ENV.eventBackendProtocol+"://"+ENV.eventBackendHost+":"+ENV.eventBackendPort+(ENV.eventBackendNamespace ? "/"+ENV.eventBackendNamespace : "")+"/events/import";
		
		const responseStream = await file.upload(url,
		{
			data:
			{
			}
		});
		
		const reader = responseStream.body.getReader();
		let response = await reader.read();
		response = new TextDecoder().decode(response.value);
		response = JSON.parse(response);
		
		this.error = response.status;
	}
}
